export const appendQueryParamToUrl = (url, queryParams = {}) => {
	const urlObject = new URL(url);
	if (urlObject) {
		for (const [key, value] of Object.entries(queryParams)) {
			urlObject.searchParams.append(key, value);
		}
	}

	return urlObject?.href || url;
};
